import React from 'react'
import type { ActionButtonProps } from './ActionButtons.types'

const ActionButton: React.FC<ActionButtonProps> = ({
  icon,
  label,
  onClick,
  tone = 'primary',
  variant = 'outline',
  size = 'md',
  disabled = false,
  darkMode = false,
  className = '',
}) => {
  const classNames = [
    'ds-action-button',
    `ds-action-button--${tone}`,
    `ds-action-button--${variant}`,
    `ds-action-button--${size}`,
    darkMode ? 'ds-action-button--dark' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <button
      type="button"
      className={classNames}
      onClick={onClick}
      disabled={disabled}
      aria-label={label}
      title={label}
    >
      <span className="ds-action-button__icon" aria-hidden="true">
        {icon}
      </span>
    </button>
  )
}

export default ActionButton
